import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ConnectionStatus } from "@/components/connection-status";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Home from "@/pages/home";
import AdminNew from "@/pages/admin-new";
import ClearProducts from "@/pages/ClearProducts";
import AdminRestaurantProducts from "@/pages/admin-restaurant-products";
import AdminRestaurantOrders from "@/pages/admin-restaurant-orders";
import AdminRestaurantDiscountCodes from "@/pages/admin-restaurant-discount-codes";
import AdminRebates from "@/pages/admin-rebates";
import AdminGuide from "@/pages/admin-guide";
import AdminSettings from "@/pages/admin-settings";
import AdminFlyers from "@/pages/admin-flyers";
import AdminFlyerEditor from "@/pages/admin-flyer-editor";
import AdminWeeklyFlyer from "@/pages/admin-weekly-flyer";
import Restaurant from "@/pages/restaurant";
import MeatPricesDisplay from "@/pages/meat-prices-display";
import MeatPriceAirport from "@/pages/meat-price-airport";
import InstoreDisplay from "@/pages/instore-display";
import ResetPassword from "@/pages/reset-password";
import NotFound from "@/pages/not-found";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/reset-password" component={ResetPassword} />
      <Route path="/restaurant" component={Restaurant} />
      <Route path="/meatprices" component={MeatPricesDisplay} />
      <Route path="/meatpriceairport" component={MeatPriceAirport} />
      <Route path="/instore" component={InstoreDisplay} />
      <Route path="/admin">
        <ProtectedRoute>
          <AdminNew />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/clear">
        <ProtectedRoute requireAdmin>
          <ClearProducts />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/restaurant/products">
        <ProtectedRoute>
          <AdminRestaurantProducts />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/restaurant/orders">
        <ProtectedRoute>
          <AdminRestaurantOrders />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/restaurant/discount-codes">
        <ProtectedRoute requireAdmin>
          <AdminRestaurantDiscountCodes />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/rebates">
        <ProtectedRoute requireAdmin>
          <AdminRebates />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/guide">
        <ProtectedRoute>
          <AdminGuide />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/settings">
        <ProtectedRoute requireAdmin>
          <AdminSettings />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/flyers">
        <ProtectedRoute>
          <AdminFlyers />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/flyers/:id/edit">
        <ProtectedRoute>
          <AdminFlyerEditor />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/weekly-flyer">
        <ProtectedRoute>
          <AdminWeeklyFlyer />
        </ProtectedRoute>
      </Route>
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TooltipProvider>
            <ConnectionStatus />
            <Toaster />
            <Router />
          </TooltipProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
